<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="cookingMethodsSelected"
    :clearable="!unclearable"
    :items="cookingMethodsItems"
    :loading="cookingMethodsLoading"
    :search-input.sync="cookingMethodsSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('CookingMethods.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import CookingMethods from "@/api/cooking_methods";

export default {
  name: "SearcherCookingMethod",

  props: {
    value: Object,
    districtID: Number,
    allianceBusinessIds: Array,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
    isActivity: Boolean,
  },

  computed: {
    cookingMethodsItems() {
      return this.cookingMethods.map((cookingMethod) => {
        const Description = cookingMethod.behavior_code + " / " + cookingMethod.behavior_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == cookingMethod.id
            )
          : false;
        return Object.assign({}, cookingMethod, { Description, disabled });
      });
    },
  },

  data: () => ({
    cookingMethods: [],
    cookingMethodsLoading: false,
    cookingMethodsSearch: "",
    cookingMethodsSelected: null,
  }),

  mounted() {
    this.getCookingMethodsFromAPI();
  },

  methods: {
    getCookingMethodsFromAPI() {
      this.cookingMethodsLoading = true;
      var options = {
        district_id: this.districtID,
        alliance_business_ids: this.allianceBusinessIds,
      };
      if (this.isActivity) {
        options.status = [1];
      }
      CookingMethods.fetchAllForSelect(options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.cookingMethods = response.data.food_behavior;
            }
            this.cookingMethodsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.cookingMethodsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.cookingMethodsSelected = this.value;
      },
    },
    cookingMethodsSelected: {
      handler() {
        this.$emit("input", this.cookingMethodsSelected);
      },
    },
    districtID: {
      handler() {
        this.getCookingMethodsFromAPI();
      },
    },
    allianceBusinessIds: {
      handler() {
        this.getCookingMethodsFromAPI();
      },
    },
  },
};
</script>
